import { Outlet, ScrollRestoration } from 'react-router';

import { PinGate } from '@/shared/components/security/PinGate';
import { OfflineBanner } from '@/shared/ui/OfflineBanner';
import { Toaster } from '@/shared/ui/Toaster';

import { CallRoot } from '@/features/calls/components/CallRoot';

import { useClearCacheOnAccountChange } from '@/app/guards';

/**
 * La racine de toutes les pages : la restauration du défilement (revenir en
 * arrière retrouve la liste là où on l'avait laissée), les messages éphémères,
 * la pastille hors ligne, la garde qui vide le cache au changement de compte,
 * et la fenêtre du code de confidentialité (une seule, ouverte de partout).
 */
export function RootLayout() {
  useClearCacheOnAccountChange();
  return (
    <>
      <ScrollRestoration />
      <Outlet />
      {/* Au-dessus des pages : un appel survit à la navigation, comme sur le téléphone. */}
      <CallRoot />
      <OfflineBanner />
      <Toaster />
      <PinGate />
    </>
  );
}
